/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
  useRef
} from 'react'

import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import Lottie from "lottie-react";

import {
  toAbsoluteUrl
} from '../../../_metronic/helpers'

import LoadingContent from '../../modules/loading/LoadingContent'
import LoadingBranch from '../../modules/loading/LoadingBranch'
import paymentAnimation  from '../../../_metronic/assets/animations/payment.json';
import paymentRejectedAnimation  from '../../../_metronic/assets/animations/paymentRejected.json';
import checkinAnimation  from '../../../_metronic/assets/animations/checkin.json';

import SupportOption from 'app/pages/HelpCenter/SupportOption';

import {
  formatLongDate,
  verifyIsToday,
} from 'app/services/dates'

import useInterval from "app/utils/useInterval";

import {
  getBrandImage,
} from "app/utils/Labels";

import {
  formatMoney,
} from 'app/services/intFormat';

import {
  fetchDayUse
} from 'app/services/dayUses';
import { MenuComponent } from '_metronic/assets/ts/components';

const DayUse = () => {
  const { auth, dayUses } = useSelector((state : any) => ({
    auth: state.auth,
    dayUses: state.dayUses,
  }), shallowEqual);

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dayUse, setDayUse] = useState<any>({});
  const [invoice, setInvoice] = useState<any>({});
  const [payment, setPayment] = useState<any>({});
  const [invoices, setInvoices] = useState<any>([]);

  const lottieRef = useRef<any>();

  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-open' }))
    }
    return () => {
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-close' }))
      }
    }
  }, []);

  useEffect(() => {
    setDayUse({});
    setInvoices([]);
    setInvoice({});
    setPayment({});

    getDayUse();
  }, []);

  useEffect(() => {
    if (dayUse.id) {
      let currentInvoice = {};

      if (dayUse.relationships.invoices.length == 1) {
        currentInvoice = dayUse.relationships.invoices[0];
      } else {
        currentInvoice = dayUse.relationships.invoices.find((value) => value.attributes.is_current == true);
      }

      setInvoice(currentInvoice);
      setInvoices(dayUse.relationships.invoices);
    }
  }, [dayUse]);

  useEffect(() => {
    if (invoice && invoice.id) {
      if (invoice.relationships.payments && invoice.relationships.payments[0] && invoice.relationships.payments[0].id) {
        let firstPayment = invoice.relationships.payments[0];
        setPayment(firstPayment);
      }
    }
  }, [invoice]);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const getDayUse = () => {
    dispatch<any>(fetchDayUse(id)).then(response => {
      setDayUse(response);
    }).catch((error) => {
      navigate('/compras/day-use');
    });
  }

  const getPaymentMethod = () => {
    if (invoice?.attributes) {
      let paymentMethod = invoice.attributes.payment_method;

      if (paymentMethod === 'credit') {
        return `Consumo de crédito`;
      }

      if (paymentMethod === 'pix') {
        return <div className="flex-column">
            <img src={toAbsoluteUrl('/media/custom/pix.png')} width="25" alt='Pix' />
            <span className="ms-3">PIX</span>
          </div>
      }

      if (paymentMethod === 'credit_card') {
        if (invoice.relationships.payments &&
          invoice.relationships.payments[0] &&
          invoice.relationships.payments[0].relationships &&
          invoice.relationships.payments[0].relationships.client_card &&
          invoice.relationships.payments[0].relationships.client_card.attributes
        ) {
          return <div className="flex-column">
            <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(invoice.relationships.payments[0].relationships.client_card.attributes.brand)}`)} width="25" alt='Pix' />
            <span className="ms-3"> ••• {invoice?.relationships?.payments[0].relationships.client_card.attributes.last_four_digits}</span>
          </div>
        }
      }
    }

    return '-';
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 1000)
  }, [dayUse]);

  // const getBranch = (value) => {
  //   if (value.relationships.origin.type == 'service') {
  //     return value.relationships.origin.relationships.fields[0].relationships.branch

  //   }

  //   if (value.relationships.origin.type == 'plan') {
  //     return value.relationships.origin.relationships.branches[0]
  //   }
  // }

  // const getTypeLabel = (value: any) => {
  //   if (value.relationships.origin.type === 'plan') {
  //     if (value.relationships.origin.attributes.type === 'day_use') {
  //       return 'Day use';
  //     }
  //   }

  //   if (value.relationships.origin.type === 'service') {
  //     if (value.relationships.origin.attributes.modality === 'reservation') {
  //       return 'Locação';
  //     }
  //     if (value.relationships.origin.attributes.modality === 'class') {
  //       return 'Aula';
  //     }
  //   }

  //   return value.relationships.origin.attributes.type;
  // }

  // const getOriginLabel = (value: any) => {
  //   if (value.attributes.type === 'branch') {
  //     return 'Concedido pela unidade';
  //   }
  //   if (value.attributes.type === 'purchase') {
  //     return 'Compra de pacote';
  //   }
  //   if (value.attributes.type === 'refund') {
  //     return 'Reposição';
  //   }

  //   return value.attributes.type;
  // }

  return (
    <>
    <div id="kt_app_content" className="flex-column-fluid">
      <span className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5" onClick={() => navigate('/compras/day-use')}>
        <i className="las la-arrow-left fw-bold fs-2 text-primary me-3" />
        Voltar
      </span>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid mb-5 mb-lg-0">
          <div className='card mb-5 mb-sm-0'>
            <div className='card-body pt-5'>
              <div className="justify-content-space-between d-flex mb-5">
                <span className="flex-root text-center fs-2 fw-bold">
                  Detalhes do day use
                </span>
              </div>
              <div className="row mt-10">
                {dayUse.relationships && dayUse.relationships.status.attributes.name == 'active' && (dayUse?.attributes?.day && verifyIsToday(dayUse.attributes.day)) && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="d-flex justify-content-center">
                      <Lottie
                        style={{
                          width: 250,
                          height: 250,
                          alignSelf: 'center',
                        }}
                        animationData={checkinAnimation}
                        loop={false}
                        autoPlay
                        rendererSettings={{
                          preserveAspectRatio: 'xMidYMid slice',
                        }}
                      />
                    </div>

                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100 mt-5">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 50,
                            height: 50,
                          }}
                          animationData={paymentAnimation}
                          loop={false}
                          autoplay
                          rendererSettings={{
                            preserveAspectRatio: 'xMidYMid slice',
                          }}
                          initialSegment={[0,22]}
                        />
                        <div className="fs-5 opacity-75 fw-bold px-3">
                          Check-in realizado
                        </div>
                      </div>
                    </div>

                    <div className="fs-6 opacity-50 mt-5">
                      Após chegar na unidade, você deve passar pela recepção para confirmar seu check-in.
                    </div>

                    <div className="fs-6 opacity-50 mt-5">
                      Seu check-in é válido somente no dia {formatLongDate(dayUse.attributes.day, true)}.
                    </div>
                  </div>
                </div>}

                {dayUse.relationships && dayUse.relationships.status.attributes.name === 'active' && (dayUse?.attributes?.day && !verifyIsToday(dayUse.attributes.day)) && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 50,
                            height: 50,
                          }}
                          animationData={paymentAnimation}
                          loop={false}
                          autoplay
                          rendererSettings={{
                            preserveAspectRatio: 'xMidYMid slice',
                          }}
                          initialSegment={[0,22]}
                        />
                        <div className="fs-5 opacity-75 fw-bold px-3">
                          Day use realizado
                        </div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu day use foi confirmado, avalie como foi sua experiência
                    </div>
                  </div>
                </div>}

                {dayUse.relationships && dayUse.relationships.status.attributes.name === 'canceled' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          lottieRef={lottieRef}
                          animationData={paymentRejectedAnimation}
                          loop={false}
                          onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                          autoplay
                        />

                        <div className="fs-5 opacity-75 fw-bold px-3">Day use cancelado</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu day use foi cancelado.
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Fique tranquilo, não foi efetuada nenhuma cobrança
                    </div>
                  </div>
                </div>}
              </div>

              {dayUse?.id && <div className="row mt-5">
                <div className="col-lg-12">
                  <div className="justify-content-space-between d-flex mb-2">
                    <span className="flex-root fs-3 fw-bold text-primary">
                      Informações
                    </span>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='border-0'>
                          <th className='p-0 w-140px'></th>
                          <th className='p-0 min-w-140px'></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Quando
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{formatLongDate(dayUse.attributes.day, true)}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              {dayUse.relationships.plan.relationships.branches.length > 1 ? 'Unidades' : 'Unidade'}
                            </span>
                          </td>
                          <td className='text-dark fw-semibold'>
                            {dayUse.relationships.plan.relationships.branches.map(branch => <span className='d-flex justify-content-end'>
                              {branch.attributes.name}
                            </span>)}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Serviço
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {dayUse.relationships.plan.attributes.name}
                          </td>
                        </tr>
                        {/* <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Tipo
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{getTypeLabel(credit)}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Aquisição
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {getOriginLabel(credit)}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}

              {dayUses.listLoading === false && !dayUse?.id && <div className="mb-13 text-center">
                <h2 className="mb-3">
                  Ops, compra não encontrada!
                </h2>
                <div className="text-muted fw-semibold fs-5">
                  Não encontramos a página que você procura!
                </div>
                <div className="text-muted fw-semibold fs-5">
                  Verifique a url ou tente novamente.
                </div>
              </div>}

              {(dayUses.listLoading === true) && !dayUse?.id && <LoadingContent />}
            </div>
          </div>
        </div>

        <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
          <div className='card mb-5'>
            <div className='card-body pt-5 pb-0 mb-5'>
              <div className="mb-5 text-center">
                <span className="flex-root text-center fs-2 fw-bold mb-3">
                  Pagamento
                </span>
              </div>
              {dayUse?.id && <>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Resumo de valores
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                        <thead>
                          <tr className='border-0'>
                            <th className='p-0 w-140px'></th>
                            <th className='p-0 min-w-140px'></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                {invoice?.attributes?.payment_type === 'online' ? 'Pagamento pelo app' : 'Pagamento'}
                              </span>
                            </td>
                            <td className='text-end text-dark fw-semibold'>
                              {invoice?.attributes?.payment_type === 'online' ? getPaymentMethod() : 'Efetuado na unidade'}
                            </td>
                          </tr>
                          {dayUse.attributes.guest === true && (<tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                Tipo de ingresso
                              </span>
                            </td>
                            <td
                              className='text-end text-dark fw-semibold'
                              data-kt-menu='true'
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-end'
                              data-kt-menu-flip='bottom-end'
                            >
                              <i className="fs-2 las la-question-circle text-primary me-2"></i>
                              Acompanhante
                            </td>

                            <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px bg-light mt-5' data-kt-menu='true'>
                              <div className='px-10 pt-3 pb-6' data-kt-user-table-filter='form'>
                                <div className='row d-flex'>
                                  <div className="col-12 d-flex flex-wrap flex-column mt-2">
                                    <span className="fs-7 fd-uppercase text-gray-800">Ingresso adquirido para um acompanhante</span>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </tr>)}
                          <tr>
                            <td>
                              <span className='fs-3 text-white fw-bold mb-1 fs-6'>
                                Total
                              </span>
                            </td>
                            <td className='fs-3 text-end text-primary fw-bold'>
                              {invoice?.attributes?.payment_type === 'online' && invoice?.attributes?.payment_method === 'credit' && <span>
                                1 Crédito
                              </span>}

                              {!(invoice?.attributes?.payment_type === 'online' && invoice?.attributes?.payment_method === 'credit') && <>
                                {invoice?.attributes?.price && invoice?.attributes?.price !== invoice?.attributes?.full_price && <span className="fs-7 text-gray-700 lineThrough me-2">
                                  {formatMoney(invoice?.attributes?.price)}
                                </span>}

                                <span>
                                  {formatMoney(invoice?.attributes?.full_price)}
                                </span>
                              </>}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Precisa de ajuda?
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <SupportOption
                        originType={'dayUse'}
                        originId={dayUse && dayUse.id}
                        canCancel={false}
                        phone={dayUse?.id && dayUse?.relationships?.plan?.relationships?.branches?.[0].attributes?.phone}
                        cancel={() => console.log(false)}
                      />
                    </div>
                  </div>
                </div>
              </>}

              {(dayUses.listLoading === true) && !dayUse?.id && <LoadingBranch />}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>)
}

export {
  DayUse
}
